import { BodyText, IconContainer } from '@utilitywarehouse/hearth-react';

import { Slider } from '@components/Slider/Slider';
import { type Category } from '@features/Cashback/Calculator/types';
import { formatNumber } from '@utils/format';

import './styles.scss';

interface CategoryProps {
  value: number;
  category: Category;
  onChange: (value: number) => void;
  max?: number;
  step?: number;
}
const Category = ({
  value,
  category,
  onChange,
  step = 1,
  max = 100,
}: CategoryProps) => {
  return (
    <div className="category__Container">
      <div className="category__Icon">
        <IconContainer size="md" variant="subtle" colorScheme={category.color}>
          {category.icon}
        </IconContainer>
      </div>
      <div className="category__SliderControls">
        <div className="category__Labels">
          <BodyText weight="semibold">{category.name}</BodyText>
          <BodyText weight="semibold">£{formatNumber(value)}</BodyText>
        </div>
        <Slider
          value={value}
          name={category.id}
          onChange={onChange}
          max={max}
          step={step}
          holdRate={125}
          holdLimit={25}
          holdInterval={10}
        />
      </div>
    </div>
  );
};

export { Category };
export type { CategoryProps };
